var _circle, _rect, _rect2, _rect3, _rect4, _g, _circle2, _g2, _g3, _g4, _g5, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8691,
    cy: 28.1016,
    r: 1.77344,
    fill: "url(#paint0_radial_715_14973)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5156,
    y: 22.1719,
    width: 6.78125,
    height: 6.71875,
    rx: 1.25,
    fill: "url(#paint1_linear_715_14973)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5156,
    y: 22.1719,
    width: 6.78125,
    height: 6.71875,
    rx: 1.25,
    fill: "url(#paint2_linear_715_14973)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5156,
    y: 22.1719,
    width: 6.78125,
    height: 6.71875,
    rx: 1.25,
    fill: "url(#paint3_radial_715_14973)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5156,
    y: 22.1719,
    width: 6.78125,
    height: 6.71875,
    rx: 1.25,
    fill: "url(#paint4_linear_715_14973)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_14973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7673 22.9687C15.7862 22.9687 15.8043 22.9688 15.8214 22.9688C16.3766 22.9663 17.6554 22.9448 18.168 22.8516C18.718 22.7516 18.789 22.4774 18.8867 22.0469C19.4891 19.3935 20.4992 18.3734 21.1749 17.6909C21.2791 17.5857 21.3754 17.4885 21.4609 17.3945C21.7542 17.0727 22.0081 16.7893 22.2019 16.5705C23.6607 15.0223 24.5547 12.936 24.5547 10.6409C24.5547 5.86447 20.6826 1.99243 15.9062 1.99243C11.1299 1.99243 7.25781 5.86447 7.25781 10.6409C7.25781 12.908 8.13016 14.9714 9.5575 16.5137C9.75677 16.7391 10.0294 17.0441 10.3488 17.3945C10.4043 17.4555 10.4644 17.5179 10.5282 17.5829C10.5627 17.618 10.5982 17.654 10.6348 17.6909C11.3105 18.3734 12.3206 19.3935 12.923 22.0469C13.0208 22.4774 13.0918 22.7516 13.6418 22.8516C14.1532 22.9446 15.1883 22.9659 15.7121 22.9685C15.7292 22.9685 15.7477 22.9687 15.7673 22.9687Z",
    fill: "url(#paint5_radial_715_14973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7673 22.9687C15.7862 22.9687 15.8043 22.9688 15.8214 22.9688C16.3766 22.9663 17.6554 22.9448 18.168 22.8516C18.718 22.7516 18.789 22.4774 18.8867 22.0469C19.4891 19.3935 20.4992 18.3734 21.1749 17.6909C21.2791 17.5857 21.3754 17.4885 21.4609 17.3945C21.7542 17.0727 22.0081 16.7893 22.2019 16.5705C23.6607 15.0223 24.5547 12.936 24.5547 10.6409C24.5547 5.86447 20.6826 1.99243 15.9062 1.99243C11.1299 1.99243 7.25781 5.86447 7.25781 10.6409C7.25781 12.908 8.13016 14.9714 9.5575 16.5137C9.75677 16.7391 10.0294 17.0441 10.3488 17.3945C10.4043 17.4555 10.4644 17.5179 10.5282 17.5829C10.5627 17.618 10.5982 17.654 10.6348 17.6909C11.3105 18.3734 12.3206 19.3935 12.923 22.0469C13.0208 22.4774 13.0918 22.7516 13.6418 22.8516C14.1532 22.9446 15.1883 22.9659 15.7121 22.9685C15.7292 22.9685 15.7477 22.9687 15.7673 22.9687Z",
    fill: "url(#paint6_radial_715_14973)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4629,
    cy: 6.95312,
    r: 3.32812,
    fill: "url(#paint7_linear_715_14973)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_715_14973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4797 22.9663C15.4446 20.7942 15.2716 19.3638 15.0081 18.3682C14.7044 17.2206 14.2795 16.6487 13.8301 16.1952L13.8244 16.1895L13.8186 16.184C13.2429 15.6393 12.8848 14.8697 12.8848 14.0156C12.8848 12.3674 14.2209 11.0312 15.8691 11.0312C17.5174 11.0312 18.8535 12.3674 18.8535 14.0156C18.8535 14.8697 18.4954 15.6393 17.9197 16.184L17.9139 16.1895L17.9082 16.1952C17.4668 16.6406 17.0363 17.1749 16.7289 18.313C16.463 19.2976 16.289 20.733 16.2544 22.9642C16.5559 22.9593 16.9167 22.9501 17.255 22.9337C17.2908 20.7658 17.4609 19.4379 17.6943 18.5737C17.9472 17.6374 18.2722 17.2491 18.6131 16.9046C19.3765 16.1793 19.8535 15.1527 19.8535 14.0156C19.8535 11.8151 18.0697 10.0312 15.8691 10.0312C13.6686 10.0312 11.8848 11.8151 11.8848 14.0156C11.8848 15.1527 12.3618 16.1792 13.1252 16.9045C13.4581 17.2414 13.7868 17.6622 14.0414 18.624C14.2739 19.5027 14.4427 20.8281 14.479 22.9343C14.8254 22.9534 15.1906 22.9625 15.4797 22.9663Z",
    fill: "#FFAD55"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_715_14973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8789 22.7385C16.8789 17.9674 17.61 17.2064 18.3942 16.4151C19.0655 15.78 19.4844 14.8807 19.4844 13.8835C19.4844 11.9592 17.9244 10.3992 16 10.3992C14.0756 10.3992 12.5156 11.9592 12.5156 13.8835C12.5156 14.8807 12.9345 15.78 13.6058 16.4151C14.39 17.2064 15.1172 18.576 15.1172 22.7385",
    stroke: "url(#paint8_linear_715_14973)",
    strokeWidth: 0.25
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_14973)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.4297,
    y: 25.1228,
    width: 6.81116,
    height: 1.07037,
    rx: 0.535186,
    transform: "rotate(-8.90493 12.4297 25.1228)",
    fill: "#7E6693"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_715_14973)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.4297,
    y: 27.4941,
    width: 6.81116,
    height: 1.07037,
    rx: 0.535186,
    transform: "rotate(-8.90493 12.4297 27.4941)",
    fill: "#7E6693"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6836,
    y: 27.4629,
    width: 8.3203,
    height: 1.10182,
    rx: 0.550908,
    transform: "rotate(-8.90493 11.6836 27.4629)",
    fill: "url(#paint9_linear_715_14973)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6836,
    y: 27.4629,
    width: 8.3203,
    height: 1.10182,
    rx: 0.550908,
    transform: "rotate(-8.90493 11.6836 27.4629)",
    fill: "url(#paint10_linear_715_14973)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6836,
    y: 27.4629,
    width: 8.3203,
    height: 1.10182,
    rx: 0.550908,
    transform: "rotate(-8.90493 11.6836 27.4629)",
    fill: "url(#paint11_linear_715_14973)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6836,
    y: 27.4629,
    width: 8.3203,
    height: 1.10182,
    rx: 0.550908,
    transform: "rotate(-8.90493 11.6836 27.4629)",
    fill: "url(#paint12_radial_715_14973)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6836,
    y: 25.0864,
    width: 8.3203,
    height: 1.10182,
    rx: 0.550908,
    transform: "rotate(-8.90493 11.6836 25.0864)",
    fill: "url(#paint13_linear_715_14973)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6836,
    y: 25.0864,
    width: 8.3203,
    height: 1.10182,
    rx: 0.550908,
    transform: "rotate(-8.90493 11.6836 25.0864)",
    fill: "url(#paint14_linear_715_14973)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6836,
    y: 25.0864,
    width: 8.3203,
    height: 1.10182,
    rx: 0.550908,
    transform: "rotate(-8.90493 11.6836 25.0864)",
    fill: "url(#paint15_linear_715_14973)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6836,
    y: 25.0864,
    width: 8.3203,
    height: 1.10182,
    rx: 0.550908,
    transform: "rotate(-8.90493 11.6836 25.0864)",
    fill: "url(#paint16_radial_715_14973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_14973",
    x: 7.25781,
    y: 1.99243,
    width: 17.5469,
    height: 21.1263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.666667 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14973"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_715_14973",
    x: 11.8848,
    y: 10.0312,
    width: 8.21875,
    height: 12.9351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.572549 0 0 0 0 0.254902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14973"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_715_14973",
    x: 12.1406,
    y: 10.0242,
    width: 7.71875,
    height: 12.9644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_14973"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_14973",
    x: 12.2559,
    y: 23.8948,
    width: 7.24219,
    height: 2.45923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_14973"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_715_14973",
    x: 12.2559,
    y: 26.2661,
    width: 7.24219,
    height: 2.45923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_14973"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_715_14973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3379 29.1094) rotate(96.6544) scale(0.943859 2.18614)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.267752,
    stopColor: "#AC90C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6AAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_14973",
    x1: 19.2969,
    y1: 25.8015,
    x2: 12.5156,
    y2: 25.8015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#947C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_14973",
    x1: 12.1808,
    y1: 26.3125,
    x2: 13.8371,
    y2: 26.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A7B88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_14973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3046 22.6404) rotate(88.6361) scale(0.824869 3.67242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.228769,
    stopColor: "#EDE2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8BCCB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_14973",
    x1: 17.4621,
    y1: 28.8906,
    x2: 17.4621,
    y2: 27.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5F9E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_14973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5558 8.12501) rotate(138.066) scale(9.91369 8.17473)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286168,
    stopColor: "#FFEC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_14973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4933 13.4375) rotate(-147.604) scale(14.5819 14.0258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.622387,
    stopColor: "#FFB239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_14973",
    x1: 16.299,
    y1: 8.02741,
    x2: 19.7205,
    y2: 5.3613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594121,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_14973",
    x1: 19.7196,
    y1: 10.9972,
    x2: 15.7143,
    y2: 20.5395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_14973",
    x1: 15.743,
    y1: 27.4722,
    x2: 15.8216,
    y2: 28.6865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_14973",
    x1: 16.7142,
    y1: 28.5416,
    x2: 16.7116,
    y2: 27.7505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A68A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC2E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_14973",
    x1: 11.586,
    y1: 28.0861,
    x2: 14.3732,
    y2: 27.9376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#958387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#958387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_14973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5798 27.8391) rotate(90.3213) scale(0.837506 4.95711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126697,
    stopColor: "#FCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C9E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_715_14973",
    x1: 15.743,
    y1: 25.0957,
    x2: 15.8216,
    y2: 26.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_14973",
    x1: 16.7142,
    y1: 26.1652,
    x2: 16.7116,
    y2: 25.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A68A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC2E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_715_14973",
    x1: 11.586,
    y1: 25.7096,
    x2: 14.3732,
    y2: 25.5611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#958387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#958387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_14973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5798 25.4626) rotate(90.3213) scale(0.837506 4.95711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126697,
    stopColor: "#FCF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C9E3",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/Light bulb.d8d3b253b35f279c746b8ec57d5f9864.svg";
export { ForwardRef as ReactComponent };